import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCallinStatus extends Layout {
    sourceCallinStatusLookup: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
